import ApiService from "../services/ApiService";
import addGoogleAnalytics from "./addGoogleAnalytics";

export const shouldShowTestGenerationDebug = async () => {
    try {
        const res = await ApiService.get("/settings");
        return (
            res?.environment === "development" ||
            res?.environment === "sandbox" 
        );
    } catch {
        return false;
    }
};

const addExternalScripts = async () => {
    try {
        const res = await ApiService.get("/settings");
        if (res.environment === "production") {
            addGoogleAnalytics(res.googleAnalyticsId);
        }
    } catch (error) {
        console.error("Failed to fetch settings", error);
    }
};

export default addExternalScripts;
